import { render, staticRenderFns } from "./SectionActivityDetail.vue?vue&type=template&id=30fc11a2"
import script from "./SectionActivityDetail.vue?vue&type=script&lang=js"
export * from "./SectionActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports